import "./Nav.css";
import logo from "../../assets/logo.png";
import Icon from "../icon/Icon";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";

const Nav = () => {
  const goToWhatsapp = () => {
    const url = `https://wa.me/5493416697243`;
    window.open(url, "_blank");
  };
  const goToInstagram = () => {
    const url = `https://www.instagram.com/tecniplus1`;
    window.open(url, "_blank");
  };

  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };

  return (
    <div className="nav">
      <button className="logo-nav" onClick={goToHome}>
        <img src={logo} alt="Logo TecniPlus+" className="logo-nav" />
      </button>
      <div className="btn-nav">
        <h1>Reparación de celulares</h1>
      </div>
      <div className="social-nav">
        <button className="btn-social" id="instagram" onClick={goToInstagram}>
          <Icon icon={faInstagram} css="instagram" className="instagram" />
        </button>
        <button className="btn-social" id="whatsapp" onClick={goToWhatsapp}>
          <Icon icon={faWhatsapp} css="whatsapp" className="whatsapp" />
        </button>
      </div>
    </div>
  );
};

export default Nav;
